import { RouterProvider } from 'react-router-dom';
import { useEffect } from 'react';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';
import useAuth from 'hooks/useAuth';

import ScrollTop from 'components/ScrollTop';
import GlobalLoader from 'components/GlobalLoader';
import GlobalNotification from 'components/GlobalNotification';
import { startTwilioRealtimeNotifications, stopTwilioRealtimeNotifications } from 'lib/realtimeTwilioNotifications';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      startTwilioRealtimeNotifications();
    } else {
      stopTwilioRealtimeNotifications();
    }

    return () => {
      stopTwilioRealtimeNotifications();
    };
  }, [isAuthenticated]);

  return (
    <ThemeCustomization>
      <ScrollTop>
        <GlobalLoader />
        <GlobalNotification />
        <RouterProvider router={router} />
      </ScrollTop>
    </ThemeCustomization>
  );
}
